import { Button } from "@ts-digital/vrc";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import VaporDrawer from "../../../../general/vapor/drawer";
import { useDispatch, useSelector } from "react-redux";
import VaporContentSwitcherTab from "../../../../vapor/contentSwitcherTab";
import ArticlesTab from "./articlesTab";
import LedgerTab from "./ledgerTab";
import AccountRegistryTab from "./accountRegistryTab";
import { getEntriesRead } from "../../../../../store/actions/reports/balance/ledger";
import "./style.css";

const DrawerDetail = ({
  invoiceId, closeFunction, visible, contiNew, setModifiedDetail, setContiNew, setExpandedRow, setPage, expandedRow, page, loadMoreItems, refCurrency, docDate, isMonoRegime, currentIsPosting, setIsDrawerToClose, contoSelected, setContoSelected
}) => {
  
  const dispatch = useDispatch();
  const [tabSelected, setTabSelected] = useState("ledger");
  const accountId = contiNew?.find(c => c.uuid === visible)?.accountCode;
  const compoundedTitle = contiNew?.find(c => c.uuid === visible)?.compoundedTitle;

  const invoiceSource = useSelector(state => state?.precog?.invoiceDetail?.data?.source);

  useEffect(() => {
    if (tabSelected === "ledger") {      
      dispatch(getEntriesRead(accountId, ""));
    }
  }, [tabSelected]);

  return (
    <VaporDrawer
      title="Dettaglio conto"
      onClose={closeFunction}
      visible={visible}
      width={1000}
      buttons={[
        <Button
          key={"saveVaporDrawerBtn"}
          onClick={() => closeFunction()}
        >
          <FormattedMessage id="preCog.saveAndClose" />
        </Button>
      ]}
    >
      <div className="dbx-precog-drawer-articles-root">
        <div className="drawer-header">
          <VaporContentSwitcherTab
            selected={tabSelected}
            itemsWidth={140}
            onChange={val => setTabSelected(val)}
            items={[
              { value: "ledger", label: <FormattedMessage id="preCog.drawerDetail.ledger" /> },
              ((currentIsPosting && invoiceSource === "B2B") && { value: "articles", label: <FormattedMessage id="preCog.drawerDetail.articles" /> }),
              { value: "accountRegistry", label: <FormattedMessage id="preCog.drawerDetail.accountRegistry" /> }
            ]}
          />
        </div>
        {tabSelected === "articles" &&
          <ArticlesTab
            invoiceId={invoiceId}
            contiNew={contiNew}
            contoId={visible}
            setModifiedDetail={setModifiedDetail}
            setContiNew={setContiNew}
            closeFunction={closeFunction}
            setExpandedRow={setExpandedRow}
            setPage={setPage}
            expandedRow={expandedRow}
            page={page}
            loadMoreItems={loadMoreItems}
            refCurrency={refCurrency}
            isMonoRegime={isMonoRegime}
            setIsDrawerToClose={setIsDrawerToClose}
            contoSelected={contoSelected}
            setContoSelected={setContoSelected}
          />
        }
        {tabSelected === "ledger" &&
          <LedgerTab docDate={docDate} accountId={accountId} compoundedTitle={compoundedTitle}/>
        }
        {tabSelected === "accountRegistry" && 
          <AccountRegistryTab account={contiNew?.find(c => c.uuid === visible)}/>
        }
      </div>
    </VaporDrawer>
  );
};

export default DrawerDetail;
